export enum TransactionRentMatchRulesTableSortColumn {
    Property,
    Tenancy,
    Description,
    Payee,
    Behaviour,
}
